import type { BsZpWard } from "@/lib/xlsx-loader"

function normalizeString(s: any) {
  return String(s || "").trim().replace(/\s+/g, " ")
}

export function parseBsZpRow(r: any[], type: "bs" | "zp"): {
  d: { en: string; hi: string; pa: string }
  b: { en: string; hi: string; pa: string }
  c: { en: string; hi: string; pa: string }
  v: { en: string; hi: string; pa: string }
  wards: BsZpWard[]
} {
  const dEn = normalizeString(r[0]), dHi = normalizeString(r[1]), dPa = normalizeString(r[2])
  let bEn = "", bHi = "", bPa = ""

  if (type === "bs") {
    bEn = normalizeString(r[3]); bHi = normalizeString(r[4]); bPa = normalizeString(r[5])
  }

  const chairBase = type === "bs" ? 6 : 3
  const cEn = normalizeString(r[chairBase]), cHi = normalizeString(r[chairBase + 1]), cPa = normalizeString(r[chairBase + 2])

  const viceBase = type === "bs" ? 9 : 6
  const vEn = normalizeString(r[viceBase]), vHi = normalizeString(r[viceBase + 1]), vPa = normalizeString(r[viceBase + 2])

  const wards: BsZpWard[] = []
  const wBase = type === "bs" ? 12 : 9
  let wIdx = 1
  for (let i = wBase; i < r.length; i += 3) {
    const wEn = normalizeString(r[i])
    const wHi = normalizeString(r[i + 1])
    const wPa = normalizeString(r[i + 2])
    wards.push({
      number: wIdx++,
      names: { en: wEn, hi: wHi, pa: wPa }
    })
  }

  let lastNonEmptyIndex = -1
  for (let i = wards.length - 1; i >= 0; i--) {
    const w = wards[i]
    if (w.names.en || w.names.hi || w.names.pa) {
      lastNonEmptyIndex = i
      break
    }
  }

  if (lastNonEmptyIndex >= 0) {
    wards.length = lastNonEmptyIndex + 1
  } else {
    wards.length = 0
  }

  return {
    d: { en: dEn, hi: dHi, pa: dPa },
    b: { en: bEn, hi: bHi, pa: bPa },
    c: { en: cEn, hi: cHi, pa: cPa },
    v: { en: vEn, hi: vHi, pa: vPa },
    wards,
  }
}

